import React from 'react'
import underConstruction from '../images/under-construction.png'

const Contact = () => (
  <div>
    <h1>Contact</h1>
    <img style={{ height: '100%', width: '100%' }} src={underConstruction} />
  </div>
)

export default Contact



// WEBPACK FOOTER //
// ./src/pages/contact.js